import React from 'react'
import MetaTags from 'react-meta-tags';

class DefaultMetaTag extends React.Component {

    render() {
        return (
            <MetaTags>
                <title>피크니키: 나들이 어디로 갈까?</title>
                <meta name="og:description" content="여행, 나들이 정보" />
                <meta property="og:title" content="피크니키" />
                <meta property="og:image" content="https://picnici.com/assets/image/intro/logo_only_192.png" />
                <meta property="og:url" content="https://picnici.com/" />
            </MetaTags>
        )
    }
}

export default DefaultMetaTag